import { useTranslation } from "react-i18next";
import { LegalShell } from "@/pages/legal/Terms";

export default function Imprint() {
  const { t } = useTranslation();
  return (
    <LegalShell title={t("lg.imprintTitle")}>
      <p>{t("lg.im.tmg")}</p>
      <div className="card-soft p-6">
        <div className="overline text-slate-400">{t("lg.im.provider")}</div>
        <p className="mt-2" dangerouslySetInnerHTML={{ __html: t("lg.im.providerP") }} />
        <div className="mt-4 overline text-slate-400">{t("lg.im.contact")}</div>
        <p className="mt-2" dangerouslySetInnerHTML={{ __html: t("lg.im.contactP") }} />
        <div className="mt-4 overline text-slate-400">{t("lg.im.responsible")}</div>
        <p className="mt-2">{t("lg.im.responsibleP")}</p>
      </div>
    </LegalShell>
  );
}
